export default __webpack_public_path__ + "static/media/IPFX.b9f6329b.svg";